import { render, staticRenderFns } from "./Proposition.vue?vue&type=template&id=70d2b868&scoped=true&"
import script from "./Proposition.vue?vue&type=script&lang=js&"
export * from "./Proposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2b868",
  null
  
)

export default component.exports